//
// client-mgmt-routing.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* jshint devel: true, jquery: true */
/* global angular: false, window: false, _: false, moment: false */

((() => {
    angular.module('curalate').config(['$routeProvider', '$locationProvider',
        ($routeProvider, $locationProvider) => {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
            }).hashPrefix('!');
            $routeProvider.
                when('/v1/client-mgmt/', {
                    templateUrl: '/app/components/client-mgmt/client-mgmt.html',
                    controller: angular.noop,
                }).
                when('/v1/client-mgmt/create', {
                    template: '<div> <client-mgmt-nav></client-mgmt-nav> <client-mgmt-create-form></client-mgmt-create-form> </div>',
                    controller: angular.noop,
                }).
                when('/v1/client-mgmt/modify', {
                    template: '<div> <client-mgmt-nav></client-mgmt-nav> <client-mgmt-modify></client-mgmt-modify> </div>',
                    controller: angular.noop,
                }).
                otherwise({
                    redirectTo: '/v1/client-mgmt/',
                });
        },
    ]);
}))();
